import React from 'react'
import { CardText, CardBody,
  CardTitle, Container, Row, Col, CardSubtitle } from 'reactstrap'
import ButtonNextWithLine from './ButtonNextWithLine'
import ButtonPrevWithLine from './ButtonPrevWithLine'
import RangeSlider from './RangeSlider'
import ButtonNext from './ButtonNext'
import ButtonPrev from './ButtonPrev'
import numeral from 'numeral'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import actionCreators from '../redux/actions'

const graphic = '/assets/doc-with-shield.svg'

function Slide7 ({ onNextRequested, onPrevRequested, onIncrementProgress, onDecrementProgress, set, netAnnualIncome, yearsOfIncomeAfterDeath }) {
  const onPrevClick = () => {
    onDecrementProgress()
    onPrevRequested()
  }

  const onNextClick = () => {
    onIncrementProgress()
    onNextRequested()
  }
  return (
    <CardBody className='app-slide Slide7 w-100'>
      <Container fluid>
        <Row>
          <Col xs={{ size: 12 }} xl={{ size: 7 }} className='d-flex'>
            <div className='d-flex mt-4 pt-2 flex-wrap'>
              <img src={graphic} className='d-block mb-5 pb-4' alt='doc and shield' />
              <div className='ml-4 mr-5'>
                <CardTitle className='pb-2 pt-2'><h2>Can you really put a price on death? Let’s determine your standard of living.</h2></CardTitle>
                <CardText className='pb-2'>Your income determines your standard of living.</CardText>
                <CardText className='pb-2'>What is your annual income?</CardText>
              </div>
            </div>
            <ButtonPrevWithLine className='d-none d-xl-block ml-5' onClick={onPrevClick} />
          </Col>
          <Col xs={12} xl={4} className='d-flex flex-column align-items-center justify-content-center pr-xl-5'>

            <h4 className='h4-slider-label'>NET ANNUAL INCOME</h4>

            <RangeSlider className='ml-3 mr-xl-3 mb-5' step={1000} minValue={0} maxValue={500000} updateRange={set} valueKey='netAnnualIncome' value={netAnnualIncome} formatLabel={(value) => `${numeral(value).format('$0,000')}`} />

            <h4 className='pt-5 h4-slider-label'>YEARS OF INCOME AFTER DEATH*</h4>

            <RangeSlider className='ml-3 mr-xl-3 mb-5' minValue={0} maxValue={18} updateRange={set} valueKey='yearsOfIncomeAfterDeath' value={yearsOfIncomeAfterDeath} />

            <CardSubtitle className='mt-1'>
              * The sliding bar automatically defaults to show the number of years before your youngest child turns 18.
            </CardSubtitle>
          </Col>
          <Col xl={1} className='d-none d-xl-block'>
            <ButtonNextWithLine onClick={onNextClick} />
          </Col>
          <Col xs={12} className='d-flex justify-content-between d-xl-none mt-5 mb-5 mb-xl-0'>
            <ButtonPrev className='ml-3' onClick={onPrevClick} />
            <ButtonNext className='mr-3' onClick={onNextClick} />
          </Col>
        </Row>
      </Container>
    </CardBody>
  )
}

const mapStateToProps = (state, props) => ({
  netAnnualIncome: state.app.netAnnualIncome,
  yearsOfIncomeAfterDeath: state.app.yearsOfIncomeAfterDeath

})

const mapDispatchToProps = dispatch =>
  bindActionCreators(actionCreators, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Slide7)
